/** The content-languages list as it is being edited, before it is saved. The first is the default. */

export const moveLanguage = (languages: Array<string>, index: number, delta: number): Array<string> => {
  const target = index + delta;

  if (index < 0 || index >= languages.length || target < 0 || target >= languages.length) {
    return languages;
  }

  const next = [...languages];

  [next[index], next[target]] = [next[target], next[index]];

  return next;
};

/** The default stays until another one has been moved first — the API refuses it too. */
export const removeLanguage = (languages: Array<string>, code: string): Array<string> =>
  languages[0] === code ? languages : languages.filter((one) => one !== code);

export const addLanguage = (languages: Array<string>, code: string): Array<string> =>
  code === '' || languages.includes(code) ? languages : [...languages, code];

export const isChanged = (saved: Array<string>, draft: Array<string>): boolean =>
  saved.join(',') !== draft.join(',');

/** The new default the draft would make, or null when it keeps the saved one. */
export const newDefault = (saved: Array<string>, draft: Array<string>): string | null =>
  draft.length > 0 && draft[0] !== saved[0] ? draft[0] : null;

/** Languages the draft removes — their texts stay stored, hidden. */
export const removedLanguages = (saved: Array<string>, draft: Array<string>): Array<string> =>
  saved.filter((code) => !draft.includes(code));
